import React from 'react';
import { useSelector } from 'react-redux';

import {
  BULK_DELETE_SBAT_GROUP_MODAL_STAGES,
  deleteSbatGroupsModalStageSelector,
} from 'features/classCreation';
import BulkDeleteSbatGroupModalConfirmStage from '../BulkDeleteSbatGroupModalConfirmStage';
import BulkDeleteSbatGroupModalInfoStage from '../BulkDeleteSbatGroupModalInfoStage';

export default function BulkDeleteSbatGroupModalStageRenderer() {
  const modalStage = useSelector(deleteSbatGroupsModalStageSelector);
  switch (modalStage) {
    case BULK_DELETE_SBAT_GROUP_MODAL_STAGES.info:
      return <BulkDeleteSbatGroupModalInfoStage />;
    case BULK_DELETE_SBAT_GROUP_MODAL_STAGES.confirm:
      return <BulkDeleteSbatGroupModalConfirmStage />;
    default:
      return null;
  }
}
